import { useDialogAction } from '@mews/framework';
import { IconButton, IconName } from '@optimus-web/core';
import { LocalProductSidePanel } from './LocalProductSidePanel';

interface Props {
    localProductId: string;
    propertyName: string;
    productName: string;
    propertyId: string;
}

export const ViewLocalProductIconButton = ({ localProductId, propertyName, productName, propertyId }: Props) => {
    const { states, handlers } = useDialogAction(async () => Promise.resolve());

    return (
        <>
            <IconButton variant="ghost" type="button" icon={IconName.ChevronRight} onClick={handlers.handleOpen} />
            {states.isDialogOpened && (
                <LocalProductSidePanel
                    localProductId={localProductId}
                    productName={productName}
                    propertyName={propertyName}
                    propertyId={propertyId}
                    onClose={handlers.handleCancel}
                />
            )}
        </>
    );
};
